// src/services/socketService.js
import { io } from 'socket.io-client';

// Store socket instance globally for the module
let _socketInstance = null;

// Initialize socket connection
export const initializeSocket = () => {
  if (_socketInstance) {
    _socketInstance.disconnect();
  }

  const token = localStorage.getItem('token');
  
  if (!token) {
    console.warn('No token found, socket connection aborted');
    return null;
  }
  
  // Extract tenant ID
  let tenantId = null;
  try {
    const tenant = localStorage.getItem('tenant');
    if (tenant) {
      const tenantData = JSON.parse(tenant);
      tenantId = tenantData._id;
    }
  } catch (e) {
    console.error('Error parsing tenant data:', e);
  }

  // Get user ID from local storage or session
  const userStr = localStorage.getItem('user');
  const userId = userStr ? JSON.parse(userStr)._id || JSON.parse(userStr).id : null;

  // Connect with all required auth data
  const socket = io(window.location.origin, {
    auth: { 
      token,
      tenantId,
      userId // Include user ID in auth
    },
    query: { tenantId },
    transports: ['websocket', 'polling']
  });
  
  _socketInstance = socket;
  
  console.log('Socket initialized with:', { 
    origin: window.location.origin,
    tenantId,
    userId,
    token: token ? token.substring(0, 10) + '...' : 'none'
  });

  // Add detailed connection event handlers
  socket.on('connect', () => {
    console.log(`Socket connected with ID: ${socket.id}`);
    // Explicitly join user room
    if (userId) {
      socket.emit('joinUserRoom', { userId });
    }
  });
  
  socket.on('connect_error', (err) => {
    console.error('Socket connection error:', err.message);
    console.error('Socket auth data:', socket.auth);
  });

  socket.on('authentication_error', (error) => {
    console.error('Socket authentication failed:', error);
  });

  socket.on('moodCheckIn', (data) => {
  console.log('Mood check-in notification received:', data);
  
  // You may also want to show browser notifications
  if ('Notification' in window && Notification.permission === 'granted') {
    const title = data.title || 'Mood Check-in';
    const options = {
      body: data.message || 'New mood check-in received',
      icon: '/favicon.ico'
    };
    new Notification(title, options);
  }
});

  return socket;
};

// Get the current socket instance
export const getSocket = () => {
  if (!_socketInstance || !_socketInstance.connected) {
    return initializeSocket();
  }
  return _socketInstance;
};

// Emit an event through the socket
export const emitEvent = (eventName, data, callback) => {
  const currentSocket = getSocket();
  if (currentSocket) {
    currentSocket.emit(eventName, data, callback);
    return true;
  }
  console.warn(`Failed to emit ${eventName}: Socket not connected`);
  return false;
};

// Subscribe to an event
export const onEvent = (eventName, callback) => {
  const currentSocket = getSocket();
  if (currentSocket) {
    currentSocket.on(eventName, callback);
    return () => currentSocket.off(eventName, callback); // Return unsubscribe function
  }
  console.warn(`Failed to subscribe to ${eventName}: Socket not connected`);
  return () => {}; // Empty unsubscribe function
};

// Close socket connection
export const closeSocket = () => {
  if (_socketInstance) {
    _socketInstance.disconnect();
    _socketInstance = null;
    console.log('Socket connection closed');
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  initializeSocket,
  getSocket,
  emitEvent,
  onEvent,
  closeSocket
};